import { render } from "./syachiku.vue?vue&type=template&id=460a711c&scoped=true"
import script from "./syachiku.vue?vue&type=script&lang=js"
export * from "./syachiku.vue?vue&type=script&lang=js"

import "./syachiku.vue?vue&type=style&index=0&id=460a711c&scoped=true&lang=css"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460a711c"]])

export default __exports__